<template>
<div class="colorgroup" :class="[isleft ? 'colorflexleft' : '']">
  <div class="bigball"
       :class="[coloridx === index ? 'active' : '', item.e_color === 'ffffff' && item.s_color === 'ffffff' ? 'whiteactive' : '']"
       v-for="(item,index) in color"
       :key="item.color_name"
       :style="{'border-color': '#'+item.e_color}"
        @click="setidx(index)">
    <div
      class="ball"
      :style="{'background-image':'linear-gradient(to bottom,#'+item.s_color+',#'+item.e_color+')'}">
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'colorSel',
  props: {
    color: {
      type: Array,
      default: () => {
        return []
      }
    },
    coloridx: {
      type: Number,
      default: 0
    },
    isleft: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    setidx (idx) {
      if (this.coloridx !== idx) {
        this.$emit('onSetidx', idx)
      }
    }
  }
}
</script>

<style scoped>

.colorgroup{
  display: flex;
  display: -webkit-flex;
  height:.9rem;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding:0 .2rem;
}
.colorflexleft{
  justify-content: flex-start!important;
}
.bigball{
  display: flex;
  display: -webkit-flex;
  justify-content: center;
  align-items: center;
  width: .64rem;
  height:.64rem;
  box-sizing: border-box;
  margin: 0 .24rem;
  flex-shrink: 0;
  border: .02rem solid;
  border-radius: 50%;
}
.ball{
  width:.48rem;
  height:.48rem;
  border-radius: 50%;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  transition: transform 0s linear;
}
.active .ball::after{
  display: block;
  content:'';
  width:.32rem;
  height:.32rem;
  background-image: url("./img/check.png");
  background-position: center;
  background-size: cover;
}
.whiteactive .ball::after{
  background-image: url("./img/wcheck.png");
}
.active .ball{
  transform: scale(1.5);
  transition: transform 0.1s linear;
}
.active{
  border:none;
}
</style>
